import Typography from '@mui/material/Typography';
import Link from 'next/link';
import styled from '@mui/styled-engine';
import { style } from '@/styles/globals';

const LinkButton = styled('button')`
  background: none !important;
  border: none;
  padding: 0 !important;
  color: ${style.color.product3};
  text-decoration: underline;
  cursor: pointer;
`;

const PassengerToPolicy = () => (
  <Typography
    variant="body2"
  >
    Bằng việc bấm nút Tiếp tục, bạn đã đồng ý với
    {' '}
    <Link
      href="/info/about-us/info-security"
    >
      <LinkButton>
        Chính sách bảo mật thông tin
      </LinkButton>
    </Link>
    {' '}
    và
    {' '}
    <Link
      href="/info/about-us/policy"
    >
      <LinkButton>
        Quy chế
      </LinkButton>
    </Link>
    {' '}
    của Goyolo.
  </Typography>
);
export default PassengerToPolicy;
